import React from 'react';
import './StreamingIndicator.css';

/**
 * Streaming indicator component
 * Shows animated dots while assistant is generating response
 */
function StreamingIndicator() {
  return (
    <span className="streaming-indicator">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </span>
  );
}

export default StreamingIndicator;
